import React from "react";
import Input from "Components/input/Input";
import Button from "Components/button/Button";
import { tzs, getPanelLangs } from "@/config";
import TranslatedString from "Components/TranslatedString";
import WarningBanner from "Components/warningBanner/WarningBanner";

import Select from "Components/select/Select";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";

import { t } from "i18next";
import cx from "classnames";
import s from "./personalDataCustomers.scss";

export default class PersonalData extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      viewFields: ["firstname", "lastname", "email_address", "whmcs_id", "distributor_id", "language", "timezone"],
    };
  }

  componentWillUnmount() {
    this.props.resetFields(...this.state.viewFields);
  }

  render() {
    const { formErrors, formData, isFormLoading, setFormFieldValue, submitForm } = this.props;

    return (
      <form className={s.registry} method="post" onSubmit={(e) => submitForm(e, this.state.viewFields)}>
        <div className={s.wrapInfoBtn}>
          <div className={s.warnignMsg}>
            {!this.props.areFieldsPristine(...this.state.viewFields) && (
              <WarningBanner color="yellow-text" msg={<TranslatedString>infoMsg.unsaveChanged</TranslatedString>} />
            )}
          </div>

          <div className={s.infoBtnGroup}>
            <Button type="submit" loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </div>
        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.customerData.title")}</div>
              <div className="sectionDesc">{t("settings.sections.customerData.desc")}</div>
            </div>
            <div className="formsSectionSP">
              <Input
                className="inputFull2"
                label={t("input.label.firstName")}
                placeholder={t("input.placeholder.firstName")}
                name="firstname"
                value={formData.firstname}
                onChange={setFormFieldValue}
                errors={formErrors.firstname}
                required
              />

              <Input
                className="inputFull2"
                label={t("input.label.lastName")}
                placeholder={t("input.placeholder.lastName")}
                name="lastname"
                value={formData.lastname}
                onChange={setFormFieldValue}
                errors={formErrors.lastname}
                required
              />

              <Input
                className="inputFull2"
                label={t("input.label.email")}
                placeholder={t("input.placeholder.email")}
                name="email_address"
                value={formData.email_address}
                onChange={setFormFieldValue}
                errors={formErrors.email_address}
                required
              />

              <Input
                className="inputFull2"
                label={t("input.label.whmcs_id")}
                placeholder={t("input.placeholder.id")}
                name="whmcs_id"
                value={formData.whmcs_id}
                onChange={setFormFieldValue}
                errors={formErrors.whmcs_id}
              />

              <Input
                className="inputFull2"
                label={t("input.label.distributor_id")}
                placeholder={t("input.placeholder.id")}
                name="distributor_id"
                value={formData.distributor_id}
                onChange={setFormFieldValue}
                errors={formErrors.distributor_id}
              />
            </div>
          </div>

          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.languageTimeZone.title")}</div>
              <div className="sectionDesc">{t("settings.sections.languageTimeZone.desc.customer")}</div>
            </div>
            <div className="formsSectionSP">
              <Select
                className={"inputAddMargin"}
                label={t("input.label.language")}
                components={{ DropdownIndicator }}
                name="language"
                options={getPanelLangs()}
                onChange={setFormFieldValue}
                value={formData.language}
                clearable={false}
              />

              <Select
                className={"inputAddMargin"}
                label={t("input.label.timezone")}
                components={{ DropdownIndicator }}
                name="timezone"
                options={tzs}
                onChange={setFormFieldValue}
                value={formData.timezone}
                required
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}
